'use strict';
export interface PersonCodeValidator {
    isValid(code:string):boolean;
    hasValidChecksum(code:string):boolean;
}

class EstonianPersonCodeValidator implements PersonCodeValidator {
    private  checksumMultipliers1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
    private  checksumMultipliers2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];

    private stringToNumberArray(str) {
        var i = 0,
            chars = str.split(''),
            arr = [];
        for (i = 0; i < chars.length; i += 1) {
            arr.push(Number(chars[i]));
        }
        return arr;
    }

    isValid(code) {
        code = String(code);
        if (!code || code.length !== 11 || !(/[0-9]{11}/.test(code))) {
            return false;
        }

        // Gender
        var first = Number(code.substring(0, 1));
        if (first < 1 || first > 8) {
            return false;
        }

        return this.hasValidChecksum(code);
    }

    hasValidChecksum(code) {
        var m1 = this.checksumMultipliers1,
            m2 = this.checksumMultipliers2,
            contentLength = code.length - 1,
            nums = this.stringToNumberArray(code),
            checkSum = 0,
            i = 0;

        for (i = 0; i < contentLength; i += 1) {
            checkSum += nums[i] * m1[i];
        }

        checkSum = checkSum % 11;
        if (checkSum === 10) {
            checkSum = 0;
            for (i = 0; i < contentLength; i += 1) {
                checkSum += nums[i] * m2[i];
            }
            checkSum = checkSum % 11;
            if (checkSum === 10) {
                checkSum = 0;
            }
        }
        return checkSum === nums[contentLength];
    }
}
class LatvianPersonCodeValidator implements PersonCodeValidator {
    private checksumMultipliers = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

    isValid(code) {
        code = String(code);
        if (!code || code.length !== 12 || !(/[0-9]{6}[\-][0-9]{5}/.test(code))) {
            return false;
        }

        if (code.substring(0, 2) !== '32') {
            // only old style codes are checked here (not starting with 32)
            var century = Number(code.substring(7, 8));
            if (century > 2) {
                return false;
            }
        }

        return this.hasValidChecksum(code);
    };

    hasValidChecksum(code) {
        var checksum = 1,
            i;
        code = code.replace('-', '');
        for (i = 0; i < 10; i++) {
            checksum -= Number(code.charAt(i)) * this.checksumMultipliers[i];
        }
        checksum = checksum - Math.floor(checksum / 11) * 11;
        if (checksum === 10) {
            checksum = 0;
        }
        if (checksum !== Number(code.charAt(10))) {
            return false;
        }

        return true;
    };
}


export class personCodeValidator {
    static EE:PersonCodeValidator = new EstonianPersonCodeValidator();
    static LT:PersonCodeValidator = new EstonianPersonCodeValidator();
    static LV:PersonCodeValidator = new LatvianPersonCodeValidator();

    static get(country):PersonCodeValidator {
        return personCodeValidator[country];
    }
}


export default personCodeValidator;


// WEBPACK FOOTER //
// ./src/ui/core/application/util/PersonCodeValidator.ts